import { ActionTree } from 'vuex'
import { ApiVersion, RootState } from '../types'
import { ChatState } from './types'
import { ChatMutations } from './mutations'
import { ChatMessages } from './types'
import axios from 'axios'
import { NotificationType, showToast } from '@/utils/Notification'

export const actions: ActionTree<ChatState, RootState> = {
  // Obtener mensajes del chat
  async getMessages(
    { commit },
    { patientId, pageNumber }: { patientId: number; pageNumber: number }
  ) {
    try {
      const { data } = await axios.get(
        `${ApiVersion.V2}/Patients/${patientId}/messages`,
        {
          params: {
            pageNumber: pageNumber,
            pageSize: 20
          }
        }
      )
      console.log('Mutations')
      console.log(data.data)

      let messages = data.data as ChatMessages[]
      if (pageNumber == 1) {
        commit(ChatMutations.SET_MESSAGES, {
          messages: [...messages].sort(
            (a, b) =>
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          ),
          totalPages: data.totalPages
        })
      } else {
        commit(ChatMutations.ADD_MESSAGES, {
          messages: [...messages].sort(
            (a, b) =>
              new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          ),
          totalPages: data.totalPages
        })
      }
    } catch (error) {
      console.error('Error al obtener mensajes:', error)
      showToast(NotificationType.DANGER, 'Error al cargar mensajes')
    }
  },

  // Enviar un mensaje
  async sendMessage(
    _,
    { patientId, message }: { patientId: number; message: string }
  ) {
    try {
      await axios.post(`${ApiVersion.V2}/Patients/${patientId}/messages/send`, {
        content: message
      })
    } catch (error) {
      console.error('Error al enviar mensaje:', error)
      showToast(NotificationType.DANGER, 'No se pudo enviar el mensaje')
    }
  }
}
